import React from 'react';
import MortgageRatesSummary from './MortgageRatesSummary.js';
import json from './block.js';
import { getMortgageRates } from '../LegalDisclosuresModal/constans.js';

// Define the type for the block that includes both Component and getBlockData.

var MortgageRatesSummaryBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs,
      _ref$blockData = _ref.blockData,
      blockData = _ref$blockData === void 0 ? {} : _ref$blockData;
    var _attrs$pathname = attrs.pathname,
      pathname = _attrs$pathname === void 0 ? '/mortgage-rates/' : _attrs$pathname;
    return /*#__PURE__*/React.createElement(MortgageRatesSummary, {
      pathname: pathname,
      blockData: blockData
    });
  },
  metadata: json,
  getBlockData: function getBlockData(_ref2) {
    return new Promise(function ($return, $error) {
      var attrs, _attrs$pathname2, pathname, data;
      attrs = _ref2.attrs;
      _attrs$pathname2 = attrs.pathname, pathname = _attrs$pathname2 === void 0 ? '/mortgage-rates/' : _attrs$pathname2;
      return Promise.resolve(getMortgageRates(pathname)).then(function ($await_1) {
        try {
          data = $await_1;
          return $return(data);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
};
var MortgageRatesSummaryBlock$1 = MortgageRatesSummaryBlock;

export { MortgageRatesSummaryBlock$1 as default };
